import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../../../../../providers/userContextProvider';
import { NumberWidget } from './numberWidget';
import { useQueryBuilder } from '../utils';

const totalManagementFeesQuery = (activeOrganization: any) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    {
      field: 'type',
      comparison: 'EQUALS',
      value: 'MANAGEMENT_FEE',
    },
    {
      field: 'date',
      comparison: 'GREATER_THAN',
      value: dayjs().startOf('month').format('YYYY-MM-DD'),
    },
  ],
  type: 'TRANSACTION',
  grouping: {
    field: null,
    interval: null,
    type: 'SINGLE_VALUE',
    valueAggregation: 'SUM',
    valueField: 'valueCents',
  },
});

const historyManagementFeesQuery = (activeOrganization: any) => ({
  filters: [
    {
      field: 'organization',
      comparison: 'EQUALS',
      value: activeOrganization.id,
    },
    {
      field: 'type',
      comparison: 'EQUALS',
      value: 'MANAGEMENT_FEE',
    },
    {
      field: 'date',
      comparison: 'GREATER_THAN',
      value: dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
    },
    {
      field: 'date',
      comparison: 'LESS_THAN',
      value: dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
    },
  ],
  type: 'TRANSACTION',
  grouping: {
    field: null,
    interval: null,
    type: 'SINGLE_VALUE',
    valueAggregation: 'SUM',
    valueField: 'valueCents',
  },
});

export const ManagementFees = () => {
  const { activeOrganization } = useContext(UserContext);
  const { t } = useTranslation('homePageConfiguration');
  const [totalManagementFees, setTotalManagementFees] = useState<number>(0);
  const [historyManagementFees, setHistoryManagementFees] = useState<number>(0);
  const { data: totalManagementFeesData, loading: totalManagementFeesLoading } = useQueryBuilder(totalManagementFeesQuery(activeOrganization));
  const { data: historyManagementFeesData, loading: historyManagementFeesLoading } = useQueryBuilder(historyManagementFeesQuery(activeOrganization));

  useEffect(() => {
    if (totalManagementFeesData?.generateReport?.grouping) {
      setTotalManagementFees(totalManagementFeesData?.generateReport?.grouping.value ?? 0);
    }
    if (historyManagementFeesData?.generateReport?.grouping) {
      setHistoryManagementFees(historyManagementFeesData?.generateReport?.grouping.value ?? 0);
    }
  }, [totalManagementFeesData, historyManagementFeesData]);

  return (
    <NumberWidget
      title={t('practiceOverview.managementFees')}
      newValue={totalManagementFees / 100 * -1}
      oldValue={historyManagementFees / 100 * -1}
      loading={totalManagementFeesLoading || historyManagementFeesLoading}
      isCurrency={true}
    />
  );
};
